var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fm-poper-select',{attrs:{"options":_vm.options,"confirm":_vm.confirm,"position":_vm.position,"clearable":_vm.clearable},on:{"change":_vm.onChange}},[_c('div',{staticClass:"type"},[_vm._v(_vm._s(_vm.label))])])}
var staticRenderFns = []

export { render, staticRenderFns }